type SyncedIconProps = {
  className?: string;
};

export const SyncedIcon: React.FC<SyncedIconProps> = ({ className }) => (
  <svg
    className={className}
    width="19"
    height="20"
    viewBox="0 0 19 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6334_21557)">
      <path
        d="M13.6586 7.41157C13.9477 7.70062 13.9477 8.16917 13.6586 8.45808L8.69442 13.4224C8.40536 13.7113 7.93695 13.7113 7.6479 13.4224L5.28475 11.0591C4.9957 10.7702 4.9957 10.3017 5.28475 10.0128C5.57366 9.7237 6.04221 9.7237 6.33112
         10.0128L8.17109 11.8527L12.6121 7.41157C12.9011 7.12266 13.3697 7.12266 13.6586 7.41157ZM18.9434 10.417C18.9434 15.6525 14.7064 19.8887 9.47168 19.8887C4.23621 19.8887 0 15.6517 0 10.417C0 5.18152 4.23693 0.945312 9.47168
          0.945312C14.7071 0.945312 18.9434 5.18225 18.9434 10.417ZM17.4634 10.417C17.4634 5.99954 13.8885 2.42526 9.47168 2.42526C5.05423 2.42526 1.47995 6.00012 1.47995 10.417C1.47995 14.8344 5.05481 18.4087 9.47168 18.4087C13.8891
           18.4087 17.4634 14.8339 17.4634 10.417Z"
        fill="#243353"
      />
    </g>
    <defs>
      <clipPath id="clip0_6334_21557">
        <rect width="18.9434" height="18.9434" fill="white" transform="translate(0 0.945312)" />
      </clipPath>
    </defs>
  </svg>
);
